// extracted by mini-css-extract-plugin
module.exports = {"ParagraphText__root":"TtGf"};